import * as React from "react";
const SvgFiRrFaceHandYawn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-hand-yawn_svg__a)">
      <path
        fill="#062147"
        d="M4.999 21.485a1 1 0 0 1-.636-.229A11.97 11.97 0 0 1 0 12C0 5.383 5.383 0 12 0s12 5.383 12 12c0 1.746-.367 3.431-1.092 5.007a1 1 0 1 1-1.816-.836A9.9 9.9 0 0 0 22 12c0-5.514-4.486-10-10-10S2 6.486 2 12a9.97 9.97 0 0 0 3.637 7.714 1 1 0 0 1-.638 1.771M6.636 8.771c1.132-.933 2.362-1.552 3.56-1.791a1 1 0 0 0 .785-1.176.997.997 0 0 0-1.176-.785c-1.521.303-3.056 1.067-4.44 2.209a.999.999 0 1 0 1.271 1.543m12.13-.128a1 1 0 0 0-.122-1.409c-1.394-1.171-2.848-1.896-4.447-2.215a1 1 0 0 0-.393 1.961c1.262.252 2.424.836 3.553 1.785a1 1 0 0 0 1.409-.122m-3.803 3.856a.829.829 0 0 1 .585 1.413l-2.961 2.961 1.002 1.002 3.634-3.634a.825.825 0 0 1 1.17 0 .83.83 0 0 1 0 1.171l-3.631 3.631.985.985 1.84-1.84a.824.824 0 0 1 1.17 0 .82.82 0 0 1 .066 1.071c-.003.029-3.426 3.47-3.426 3.47a4.32 4.32 0 0 1-3.064 1.267c-1.43 0-2.858-.701-3.722-2.102-.425-.69-.612-1.505-.612-2.316v-3.58a1 1 0 0 1 2 0v1.119l4.377-4.377a.82.82 0 0 1 .585-.242zm-5.962.498c.646 0 1.246.205 1.736.555l2.227-2.227c.576-.576 1.382-.831 2.171-.786a3.98 3.98 0 0 0-3.134-1.542 4 4 0 0 0-4 4c0 .061.015.118.018.179.309-.108.636-.179.982-.179"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-hand-yawn_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceHandYawn;
